import { apiClient } from './client'

export type EvaluateAllHikeDifficultiesResult = {
  popularHikesEvaluated: number
  tourOperatorHikesEvaluated: number
  totalEvaluated: number
}

export async function evaluateAllHikeDifficulties() {
  const { data } = await apiClient.post<EvaluateAllHikeDifficultiesResult>(
    '/api/admin/hike-difficulty/evaluate-all'
  )
  return data
}
